export const shippingSpeed: any = {
  NDA: 'NDA',
  days_2: '2 day delivery',
  days_3: '3 day delivery',
  ground: 'ground',
}
